import type React from 'react';

export interface HorizontalBarsIconProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	stroke?: string;
	'aria-label'?: string;
}

const HorizontalBarsIcon: React.FC<HorizontalBarsIconProps> = ({
	width = 16,
	height = 15,
	fill = 'currentColor',
	stroke = 'none',
	'aria-label': ariaLabel = 'Horizontal Bars Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 16 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
	>
		<title>{ariaLabel}</title>
		<rect y="0.5" width="16" height="2" rx="1" fill={fill} stroke={stroke} />
		<rect y="4.5" width="16" height="2" rx="1" fill={fill} stroke={stroke} />
		<rect y="8.5" width="16" height="2" rx="1" fill={fill} stroke={stroke} />
		<rect y="12.5" width="16" height="2" rx="1" fill={fill} stroke={stroke} />
	</svg>
);

export default HorizontalBarsIcon;
